
<div class="">
    <button mat-flat-button class="new-sorting-btn start-sm-0" [matMenuTriggerFor]="dateList"
      [ngClass]="{'active': isDateApply}" (click)="!isDateApply && calenderValue('Current Month')">
      <div class="d-flex align-items-center">
        <div class=" " (click)="isDateApply && removeDateFilter()">
       <img src="../../../../assets/images/plus-circle.svg" alt="">
        </div>

        <span class="ms-2">Status <span *ngIf="isDateApply">| </span></span>

        <h6 class="m-0 ms-1" *ngIf="isDateApply"> {{selectedOption}}</h6>
      </div>
    </button>

    <div>
      <mat-menu #dateList="matMenu" class="new-mat-menu mt-1 dateFilter">
        <div class="p-3" (click)="stopPropagation($event)" style="box-sizing: border-box; width: 100%;">
          <p class="mb-1" style="font-size: 13px; font-weight: 700; color: #1e293b; font-family: 'Gilroy', sans-serif;">Filter by status</p>
          <div class="">
            <mat-form-field class="header-select-box nav-md bell-btn w-100" appearance="outline"
              (click)="stopPropagation($event)">
              <mat-select [(ngModel)]="selectedOption" placeholder="Select">
                <mat-option class="custom-height-menu" value="Current Month"
                  (click)="calenderValue('Current Month')">
                  Collecting
                </mat-option>
                <mat-option class="custom-height-menu" value="Last Month" (click)="calenderValue('Last Month')">
                  Demo
                </mat-option>
                <mat-option class="custom-height-menu" value="Current Quarter"
                  (click)="calenderValue('Current Quarter')">
                  Demo
                </mat-option>
                <mat-option class="custom-height-menu" value="Last Quarter"
                  (click)="calenderValue('Last Quarter')">
                  Demo
                </mat-option>
                <mat-option class="custom-height-menu" value="Current FY" (click)="calenderValue('Current FY')">
                  Demo
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div class="d-flex align-items-center mt-2 DatepickOpen" *ngIf="DatepickOpen">
              <div class="w-20">

                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="me-2 ms-3">
                  <path d="M12.5 8.33331L16.6667 12.5L12.5 16.6666" stroke="#0386FF" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M3.33301 3.33331V9.16665C3.33301 10.0507 3.6842 10.8985 4.30932 11.5237C4.93444 12.1488 5.78229 12.5 6.66634 12.5H16.6663"
                    stroke="#0386FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>

              <div class="w-80">

                <div class="date-picker-custom w-100">
                  <mat-form-field class="header-select-box w-100" (click)="stopPropagation($event)">
                    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" readonly
                      (click)="picker.open()">
                      <input matStartDate formControlName="start" placeholder="Start date"
                      readonly (click)="picker.open()">

                      <input matEndDate formControlName="end" placeholder="End date" readonly (click)="picker.open()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>

                    <mat-date-range-picker #picker>
                      <mat-date-range-picker-actions>
                        <button class="secondary-btn date mx-2" mat-button matDateRangePickerCancel
                          *ngIf="!rangeData">Cancel</button>
                        <button class="secondary-btn date mx-2" mat-button matDateRangePickerCancel
                          (click)="cancelBtn()" *ngIf="rangeData">Cancel</button>
                        <button class="primary-btn date" mat-raised-button color="primary"
                          (click)="customDate()" matDateRangePickerApply>Apply</button>
                      </mat-date-range-picker-actions>
                    </mat-date-range-picker>


                  </mat-form-field>

                </div>
              </div>
            </div>



            <button mat-flat-button class="btn blue-btn w-100 mt-4" [disabled]="!csvEndDate"
              (click)="applyDate()">
              <div class="d-flex align-items-center justify-content-center">
                APPLY
              </div>
            </button>

          </div>
        </div>

      </mat-menu>
    </div>

  </div>